// app.module.ts
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

import { QuillModule } from 'ngx-quill';
import { CommonModule } from '@angular/common';
import { UserListComponent } from './auth/user/user-list/user-list.component';
import { LoginComponent } from './auth/login/login.component';
import { RoleListComponent } from './auth/roles/role-list/role-list.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { HeaderComponent } from './shared/header/header.component';
import { GenaiDialogComponent } from './shared/genai-dialog/genai-dialog.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';

import { ProjectListComponent } from './auth/projects/project-list/project-list.component';
import { TokenInterceptor } from './shared/token-interceptor/token.interceptor';
import { ProjectEnvEditorComponent } from './auth/projects/project-form/components/project-env-editor/project-env-editor.component';
import { AccordionModule } from 'primeng/accordion';
import { ProjectFormComponent } from './auth/projects/project-form/project-form.component';
import { ResizableColumnDirective } from './shared/directives/resizable-column.directive';
import { UserFormComponent } from './auth/user/user-form/user-form.component';
import { RoleFormComponent } from './auth/roles/role-form/role-form.component';
import { ProjectIdInterceptor } from './auth/interceptors/project-id.interceptor';
import { MicroServiceListComponent } from './auth/micro-service/micro-service-list/micro-service-list.component';
import { MicroServiceFormComponent } from './auth/micro-service/micro-service-form/micro-service-form.component';
import { AiAgentsModule } from './ai-agents/ai-agents.module';


@NgModule({
  declarations: [
    AppComponent,
    UserListComponent,
    LoginComponent,
    RoleListComponent,
    SignUpComponent,
    HeaderComponent,
    GenaiDialogComponent,
    SidebarComponent,
    ProjectFormComponent,
    ProjectListComponent,
    ProjectEnvEditorComponent,
    ResizableColumnDirective,
    UserFormComponent,
    RoleFormComponent,
    MicroServiceListComponent,
    MicroServiceFormComponent,
    //UserDetailsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    AiAgentsModule,
    AppRoutingModule,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    AccordionModule,
    QuillModule.forRoot(),

  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProjectIdInterceptor,
      multi: true
    }
  ]
})
export class AppModule { }
